// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"122":"css/documentations","252":"css/app","299":"css/nova-non-prod"}[chunkId] + ".css";
};